export default (key, { defaultValue } = {}) => {
  const getValue = () => localStorage.getItem(key) || defaultValue;
  const setValue = value => localStorage.setItem(key, value);

  return [getValue, setValue];
};
